@layer module {
.status-badge {
            display: inline-flex;
            align-items: center;
            white-space: nowrap;
    }

.status-badge::before {
            content: '';
    }

.status-badge.plain::before {
            content: none;
    }
} // layer module










@layer app {
.status-badge {
            gap: $size-6;
            border-radius: 999px;
            padding: $size-4 $size-12;
    }

.status-badge::before {
            width: $size-7;
            height: $size-7;
            border-radius: 50%;
    }

.status-badge.plain {
            border-radius: $size-8;
            padding: $size-4 $size-12;
    }

.status-badge {
            font-size: var(--font-size-sm);
            font-weight: 700;
    }

.status-badge::before {
            background: currentColor;
    }

.success {
            color: var(--color-success);
            background-color: var(--color-tint-success);
    }

.warning {
            color: var(--color-warning-fg);
            background-color: var(--color-tint-warning);
    }

.error {
            color: var(--color-error);
            background-color: var(--color-tint-error);
    }

.brand {
            color: var(--color-brand);
            background-color: var(--color-brand-tint);
    }

.action {
            color: var(--color-on-action);
            background-color: var(--color-action-tint);
    }

.neutral {
            color: var(--text-body);
            background-color: var(--bg-neutral-chip);
    }

.status-badge.plain {
            font-weight: 500;
    }
} // layer app
